import { style } from '@vanilla-extract/css';

export const badge = style({
  maxWidth: 300,
});

export const postLabelIcon = style({
  flexShrink: 0,
  width: 16,
  height: 16,
});

export const labelContent = style({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
